import { ScriptService } from './../../../services/cms/script.service';
//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Input, Inject, Renderer } from "@angular/core";

//Services
import { ClientAreaService } from "./../../../services/settings/client-area.service";
import { LanguageService } from "./../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { AuthService } from "./../../../services/core/auth.service";
import { TemplateService } from "./../../../services/settings/template.service";
import { Router } from "@angular/router";
import { RoutesService } from "./../../../services/core/routes.service";
import { TranslateService } from "@ngx-translate/core";
import { SeoService } from "../../../services/core/seo.service";
import { BreadcrumbsService } from './../../../services/cms/breadcrumbs.service';

//Models
import { ClientAreaOrderDetails } from "./../../../models/settings/client-area";
import { CookieService } from "../../../services/core/cookie/cookie.service";
import { ApiService } from "../../../services/core/api.service";
import { MessagesService } from "../../../services/core/messages.service";
import { Mappings } from "../../../shared/mapping";
import { Breadcrumbs } from './../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";
import { SeoViewModel } from '../../../models/core/seo';

@Component({
    template: ""
})
export class ClientAreaOrderListComponent implements OnInit {
    constructor
        (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private templateService: TemplateService,
        private authService: AuthService,
        private router: Router,
        private clientAreaService: ClientAreaService,
        @Inject('isBrowser') private isBrowser: boolean,
        private seo: SeoService,
        private renderer: Renderer,
        @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        let ClientAreaOrderListTemplate: any;

        let userId = this.authService.GetUserId();
        let showAll: string = "-1"

        let orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, showAll, showAll, showAll, showAll).subscribe(result => {

            ClientAreaOrderListTemplate = result;

            // Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(ClientAreaOrderListTemplate);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

        })

        this.subManager.add(orderListSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(ClientAreaOrderListTemplate: any) {

        @Component({
            template: ClientAreaOrderListTemplate.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                @Inject('CookieService') private cookie: CookieService,
                private clientAreaService: ClientAreaService,
                private router: Router,
                private authService: AuthService,
                private routesService: RoutesService,
                private apiService: ApiService,
                private messagesService: MessagesService,
                private mappings: Mappings,
                private languageService: LanguageService,
                private translateService: TranslateService,
                @Inject('isBrowser') private isBrowser: boolean,
                private seoService: SeoService,
                private breadcrumbsService: BreadcrumbsService,
                private scriptService: ScriptService            
                ) { }

            private pageIsInit: boolean = false;

            public rows: Array<any> = [];

            public columns: Array<any> = [];

            //translating of header columns titles
            translateTableColumnTitle(columnTitle) {
                let translation = this.translateService.get(columnTitle)["value"];
                return translation;
            }

            @Input() clientModel: Array<ClientAreaOrderDetails>;

            private status: string = "0";
            private orderNumber: string = "";

            private lang: string = this.languageService.getLongLang();
            private shortLang: string = this.languageService.getShortLang();

            private modalTitle: string = "MESSAGES:";
            private modalBody: string = "";
            private numberOfMessages: number = 0;
            private bodyMod = [];

            private from: any;
            private to: any;
            private load: boolean = true;

            //checking if invoices and multiple shipment modules are active
            private multipleShipmentActive: boolean = ClientAreaOrderListTemplate.isActiveMultipleShipment;
            private isActiveInvoicesModule: boolean = ClientAreaOrderListTemplate.isActiveInvoicesModule;

            private breadcrumbs : Breadcrumbs[] = ClientAreaOrderListTemplate.BreadcrumbsInfo;

            //Routes for menu-tabs
            private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
            private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
            private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');

            currentLang;
            italianLang = {
                "sProcessing": "Attendere...",
                "sLengthMenu": "Visualizza _MENU_ record per pagina",
                "sZeroRecords": "Niente trovato",
                "sInfo": "Mostra _START_ a _END_ di _TOTAL_ record",
                "sInfoEmpty": "Non ci sono record",
                "sInfoFiltered": "(filtrato da _MAX_ record totali)",
                "sInfoPostFix": "",
                "sUrl": "",
                "oPaginate": {
                    "sPrevious": "«",
                    "sNext": "»"
                }
            }

            englishLang = {
                "oPaginate": {
                    "sPrevious": "«",
                    "sNext": "»"
                }
            }

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                if (this.multipleShipmentActive == false) {
                    this.columns = [
                        { title: '' },
                        { title: this.translateTableColumnTitle("Jobname") },
                        { title: this.translateTableColumnTitle("OrderNumber") },
                        { title: this.translateTableColumnTitle("OrderDate") },
                        { title: this.translateTableColumnTitle("PriceCell") },
                        { title: this.translateTableColumnTitle("Status") },
                        { title: this.translateTableColumnTitle("FileVerification") },
                        { title: this.translateTableColumnTitle("Payment") },
                        { title: this.translateTableColumnTitle("Shipment") },
                        { title: '' },
                        { title: '' },
                    ];
                }

                else {
                    this.columns = [
                        { title: '' },
                        { title: this.translateTableColumnTitle("Jobname") },
                        { title: this.translateTableColumnTitle("OrderNumber") },
                        { title: this.translateTableColumnTitle("OrderDate") },
                        { title: this.translateTableColumnTitle("PriceCell") },
                        { title: this.translateTableColumnTitle("Status") },
                        { title: this.translateTableColumnTitle("FileVerification") },
                        { title: this.translateTableColumnTitle("Payment") },
                        { title: '' },
                        { title: '' },
                    ];
                }

                //getting of Datatable data
                this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;
                this.load = false;
            }

            ngAfterViewChecked() {

                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                if (this.shortLang == 'en') {
                    this.currentLang = this.englishLang;
                }
                else {
                    this.currentLang = this.italianLang;
                }

                //initialization of datatable
                $('#datatable').DataTable({
                    searching: false,
                    ordering: false,
                    sDom: 'Rlfrtlip',
                    oLanguage: this.currentLang
                });

                //hiding of first 'per page' section, because we added it on the bottom of the table
                $('.dataTables_length').not(':eq(1)').hide();


                //initialization of datetime picker from and to
                $('#fromDate').datetimepicker(
                    {
                        locale: this.shortLang,
                        format: 'DD/MM/YYYY'
                    }
                );

                $('#toDate').datetimepicker(
                    {
                        locale: this.shortLang,
                        useCurrent: false, //Important! See issue #1075
                        format: 'DD/MM/YYYY'
                    }
                );

                $("#fromDate").on("dp.change", function (e) {
                    $('#toDate').data("DateTimePicker").minDate(e.date);
                }
                );

                $("#toDate").on("dp.change", function (e) {
                    $('#fromDate').data("DateTimePicker").maxDate(e.date);
                }
                );

                this.pageIsInit = true;
            }

            onClick(indexRow: any, columnName?: string) {
                let indexColumn;
                let orderId = this.rows[indexRow].OrderId;

                if (columnName == undefined) {
                    let orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE')[0];

                    orderDetailsPage = orderDetailsPage.replace(':id', orderId.toString());

                    this.router.navigate([orderDetailsPage]);
                }
                else if (columnName == 'Upload') {
                    let loginRoute = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
                    loginRoute = loginRoute.replace(":id", orderId);
                    loginRoute = loginRoute.replace(":pagefrom", "section_upload");

                    this.router.navigate([loginRoute]);
                }
                else if (columnName == 'OrderNotesCell') {
                    let order = this.rows[indexRow];

                    //Reading only the messsages for the selected order
                    this.bodyMod = order.OrderNoteList;
                    this.numberOfMessages = this.bodyMod.length;

                    //The modal is showed only if there are messages
                    if (this.bodyMod.length > 0) {
                        let userId = this.authService.GetUserId();
                        let params =
                            {
                                CustomerId: userId.toString(),
                                OrderId: orderId.toString(),
                                Lang: this.lang
                            };

                        //setting messages as read
                        let messReadSub = this.messagesService.setMessagesAsRead(params)
                            .subscribe(result => { })

                        this.subManager.add(messReadSub);

                        this.showModal();

                        //reseting of value of OrderNoteList
                        order.OrderNoteList = []
                    }
                }
            }

            showModal() {
                $("#messagesModal").modal("show");
            }

            hideModal() {
                $('#basic').modal('hide');

                this.bodyMod = [];
            }

            getOrdersList(userId: string, dateFrom: string, dateTo: string, orderNumber: string, orderStatus: string) {
                this.load = true;
                let orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, dateFrom, dateTo, orderNumber, orderStatus)
                    .subscribe(result => {

                        this.rows = result.ClientAreaOrderList;

                        this.load = false;

                        this.resetTable(this.rows);
                    })
                
                this.subManager.add(orderListSub);
            }

            //destroying of current context of table and creating a new one with new data
            resetTable(tableData) {
                $('#datatable').DataTable().destroy();
                let currentLang = this.currentLang;
                setTimeout(function () {
                    $('#datatable').DataTable
                        (
                        {
                            data: this.rows,
                            searching: false,
                            ordering: false,
                            sDom: 'Rlfrtlip',
                            oLanguage: currentLang
                        }
                        );
                }, 0);

                setTimeout(function () { $('.dataTables_length').not(':eq(1)').hide() }, 0);
            }

            resetFilter() {
                this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;

                this.resetTable(this.rows);
            }

            filterOrdersList() {
                let orderStatus: string;
                let numberOfOrder: string;

                let userId = this.authService.GetUserId();
                this.from = $('#fromDate').val();
                this.to = $('#toDate').val();

                let dateFrom = this.changeDate(this.from);
                let dateTo = this.changeDate(this.to);

                if (dateFrom == "") {
                    dateFrom = "-1";
                }

                if (dateTo == "") {
                    dateTo = "-1";
                }

                if (dateFrom == "Invalid date" || null) {
                    dateFrom = "-1";
                }

                if (dateTo == "Invalid date" || null) {
                    dateTo = "-1";
                }

                if (this.status == "0") {
                    orderStatus = "-1";
                }

                else {
                    orderStatus = this.status
                }

                if (this.orderNumber == "") {
                    numberOfOrder = "-1";
                }

                else {
                    numberOfOrder = this.orderNumber
                };

                this.getOrdersList(userId, dateFrom, dateTo, numberOfOrder, orderStatus);
            }

            changeDate(stringDate) {
                let date = stringDate.replace(/\//g, "-");
                return date;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }
        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/sys/client-area-order-list.component.ts